/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { DeviceType, DeviceTypeMap } from "~/constants";
import { PlatformStatsDeviceRecord } from "~/features/dashboard/types";
import { PlatformStats } from "~/features/statistics/types";

const transformToPlatformStats = (apiData: PlatformStats["data"]): Record<string, PlatformStatsDeviceRecord> => {
  const transformed: Record<string, PlatformStatsDeviceRecord> = {};

  let netRevenue = 0;

  apiData.items.forEach((device) => {
    const deviceType = DeviceTypeMap[device.device];

    if (deviceType === DeviceType.DESKTOP || deviceType === DeviceType.MOBILE || deviceType === DeviceType.TABLET) {
      transformed[deviceType] = {
        deviceType,
        netRevenue: Number(device.netRevenue),
      };
    } else {
      netRevenue += Number(device.netRevenue);
    }
  });

  if (netRevenue === 0) {
    return transformed;
  } else {
    transformed[DeviceType.OTHER] = {
      deviceType: DeviceType.OTHER,
      netRevenue: netRevenue,
    };
  }

  return transformed;
};

export default transformToPlatformStats;
